import { MdHomeWork, MdOutlineCheckCircle, MdOutlinePeople, MdTrendingUp, MdAttachMoney, MdVisibility } from 'react-icons/md';
import { formatRupiah } from '../../utils/currency';
import { formatNumber } from '../../utils/number';

const ICONS = {
  listings: { Icon: MdHomeWork, className: 'kpi-card__icon--listings' },
  sold: { Icon: MdOutlineCheckCircle, className: 'kpi-card__icon--sold' },
  leads: { Icon: MdOutlinePeople, className: 'kpi-card__icon--leads' },
  rate: { Icon: MdTrendingUp, className: 'kpi-card__icon--rate' },
  revenue: { Icon: MdAttachMoney, className: 'kpi-card__icon--revenue' },
  views: { Icon: MdVisibility, className: 'kpi-card__icon--views' },
};

const KpiCard = ({ icon, label, value, sub, subClassName }) => {
  const { Icon, className } = ICONS[icon] || ICONS.listings;

  return (
    <article className="kpi-card">
      <div className="kpi-card__top">
        <div className={`kpi-card__icon ${className}`}>
          <Icon size={22} />
        </div>
        <div className="kpi-card__label">{label}</div>
      </div>
      <div className="kpi-card__value">{value}</div>
      {sub && <div className={`kpi-card__sub ${subClassName || ''}`}>{sub}</div>}
    </article>
  );
};

const AnalyticsKPICards = ({ kpi }) => {
  if (!kpi) return null;

  const cards = [
    {
      icon: 'listings',
      label: 'Total Listings',
      value: formatNumber(kpi.total_listings),
      sub: `${formatNumber(kpi.total_listings)} Properti`,
    },
    {
      icon: 'sold',
      label: 'Terjual / Disewa',
      value: formatNumber(kpi.total_sold_rented),
      sub: `${formatNumber(kpi.sold_count)} Terjual, ${formatNumber(kpi.rented_count)} Disewa`,
      subClassName: 'kpi-card__sub--green',
    },
    {
      icon: 'leads',
      label: 'Total Leads',
      value: formatNumber(kpi.total_leads),
      sub: `${formatNumber(kpi.total_leads)} Inquiry`,
    },
    {
      icon: 'views',
      label: 'Total Dilihat',
      value: formatNumber(kpi.total_views),
    },
    {
      icon: 'rate',
      label: 'Conversion Rate',
      value: `${kpi.conversion_rate}%`,
      sub: `${formatNumber(kpi.total_sold_rented)} / ${formatNumber(kpi.total_leads)}`,
    },
    {
      icon: 'revenue',
      label: 'Total Revenue',
      value: formatRupiah(kpi.total_revenue),
    },
  ];

  return (
    <div className="kpi-grid">
      {cards.map((card) => (
        <KpiCard key={card.icon} {...card} />
      ))}
    </div>
  );
};

export default AnalyticsKPICards;
